import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
  selector: 'app-codalt-button',
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent {
    text = input<string | number>();
    icon = input<string>();
    disabled = input<boolean>(false);
    light = input<boolean>(false);
    dark = input<boolean>(false);

    clicked = output<void>();
}
